"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "attendeeNetworkHealthEmitter", {
  enumerable: true,
  get: function get() {
    return _attendeeNetworkHealthEmitter["default"];
  }
});
var _attendeeNetworkHealthEmitter = _interopRequireDefault(require("./attendeeNetworkHealthEmitter"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }